import { Container, Point, Text, TextStyle } from "pixi.js";
import { degreesToRadians } from "../utils/math";

type Instructions = {
  container: Container;
};

const STYLE: Partial<TextStyle> = {
  fontFamily: "Press Start 2P",
  fontSize: 16,
  fill: "white",
  align: "center",
};

export function createInstructions(): Instructions {
  const container = new Container();
  container.position.x = -16;
  container.position.y = -16;

  const up = new Text({ text: "↑", style: STYLE });
  up.position.y = -43;

  const down = new Text({ text: "↑", style: STYLE });
  down.scale.y = -1;
  down.position.y = 73;

  const left = new Text({ text: "↑", style: STYLE });
  left.rotation = degreesToRadians(90);
  left.position.x = 73;

  const right = new Text({ text: "↑", style: STYLE });
  right.rotation = degreesToRadians(90);
  right.scale.y = -1;
  right.position.x = -58;

  container.addChild(up);
  container.addChild(down);
  container.addChild(left);
  container.addChild(right);

  return { container };
}
